import { mergeReducers } from 'use-redux-states';
import app from './app';
import auth from './auth';
import call from './call';
import esainiDoc from './esainiDoc';

const reducers = mergeReducers({ app, auth, call, esainiDoc });

export default reducers;
